import * as mailTemplate from '../services/mailTemplate';

export default {
  namespace: 'mailTemplate',
  state: {},
  effects: {
    *getQueryMailTemplate({ payload: { values } }, { call, put }) {
      const response = yield call(mailTemplate.getQueryMailTemplate, values);
      yield put({
        type: 'save',
        payload: {
          mailTemplateList: response.data.data,
          total: response.data.total,
        },
      });
    },
    *deleteMailTemplate({ payload: { values }, callback }, { call }) {
      const response = yield call(mailTemplate.deleteMailTemplate, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
